import React from "react";
const globalContext: React.Context<any> = React.createContext({});
globalContext.displayName = 'GlobalContext';
export default globalContext;